<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('option.title', 'Опції') }}</h1>
          <!--<div class="caption" v-if="selected">{{selected.option}}</div>-->
        </div>
        <div class="tabs-wrapper">
          <div class="tab-links-holder d-flex align-items-center">
            <ul class="tab-links">
              <!--            <li class="tab-link"-->
              <!--                :class="{'active': option_id==='tags'}">-->
              <!--              <router-link class="default-btn"-->
              <!--                           :class="{'transparent-btn': option_id!=='tags', 'btn-white': option_id==='tags' }"-->
              <!--                           :to="{name: 'Options', params:{option_id: 'tags'}}">-->
              <!--                Тег-->
              <!--              </router-link>-->
              <!--            </li>-->
              <li class="tab-link" v-for="(item, index) in settings" :key="index"
                :class="{ 'active': option_id === item.option_id }" style="max-width: 100%;overflow-x: auto">
                <router-link class="default-btn"
                  :class="{ 'transparent-btn': option_id !== item.option_id, 'btn-white': option_id === item.option_id }"
                  :to="{ name: 'Options', params: { option_id: item.option_id } }">
                  <!-- {{ (item.option_id != 'tags' &&
                    item.option_id != 'ingredient') ? this.$dynamic(item, item.option,
                      'option') : item.option }} -->
                  {{ $dynamic(item, item.option, 'option') }}
                  <!-- тут переводятся и tags и
                    badges (теги и метки), но для них translate присваивается в свойстве settings -->
                </router-link>
              </li>
            </ul>
            <div class="create-option">
              <div class="tip" style="position:relative;white-space: nowrap">
                <Popper arrow content="Створити опцію" hover placement="top">
                  <router-link class="btn-icon btn-rounded " :to="{ name: 'SettingsOptions' }">
                    <span class="icon icon-add"></span>
                  </router-link>
                </Popper>
              </div>

            </div>
          </div>
          <div class="tab-content-wrapper" v-if="settings.length">
            <Teleport to="body">
              <div class="picket-container" style="position: absolute;z-index: 11" v-if="colors"
                :style="{ left: colorPicker.x + 'px', top: colorPicker.y + 'px' }">
                <chrome-picker v-model="colors"></chrome-picker>
              </div>
            </Teleport>

            <div class="tab-body panel" v-if="selectedSettings">
              <div class="d-flex align-items-center mb-1">
                <h3 style="margin-bottom:10px;">{{ $static('option.translate', 'Переклади') }}</h3>
                <lang-selector v-model="lang"></lang-selector>
              </div>
              <div class="repeater">
                <div class="repeat-top d-flex w-100">
                  <div class="name custom-label tag-name"
                    :class="{ 'w-20': !(is_tag || is_ingredient), 'w-40': (is_tag || is_ingredient) }">
                    {{ $dynamic(selectedSettings, selectedSettings.option, 'option') }}
                    <!-- тут переводятся и tags и
                    badges (теги и метки), но для них translate присваивается в свойстве settings -->
                  </div>
                  <div class="d-flex price-name-group w-30" v-if="!(is_tag || is_ingredient)">
                    <div class="name  custom-label w-50" style="padding-left:20px">
                      {{ $static('option.price', 'Ціна') }}
                    </div>
                    <div class="name custom-label w-50" style="padding-left:20px">
                      {{ $static('option.old_price', 'Стара ціна') }}
                    </div>
                  </div>
                  <div class="d-flex color-name-group w-10" style="padding-left:15px">
                    <div class="name custom-label w-50" style="padding-left:0">{{ $static('option.imag', 'Img') }}
                    </div>
                    <div class="name custom-label w-50">{{ $static('option.color', 'Колір') }}</div>
                  </div>
                </div>
                <!--                <transition-group name="flip-list" tag="div">-->
                <OptionEditorFull v-for="(i, index) in list" :key="i._id" :item="i" :lang="lang" @remove="remove(index)"
                  @down="swap(index, index + 1)" @up="swap(index, index - 1)"
                  @color="(event) => openColorPicker(event, i)" :swappable="true" />
                <!--                </transition-group>-->
                <a href="javascript:void(0)" class="default-link" @click="addMore">
                  <span class="text">{{ $static('option.add', 'Додати більше') }}</span>
                  <span class="icon icon-add"></span>
                </a>
              </div>

              <div class="button-panel">
                <button class=" default-btn btn-accent" @click="save">
                  <span class="text">{{ $static('option.save', 'Зберегти зміни') }}</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { Chrome } from '@lk77/vue3-color'
import LangSelector from '../components/LangSelector';
import OptionEditor from '../components/OptionEditor';
import OptionEditorFull from '../components/OptionEditorFull';
// import { Chrome } from 'vue-color'

export default {
  name: 'Options',
  props: [
    'option_id'
  ],
  components: {
    OptionEditorFull,
    OptionEditor,
    LangSelector,
    'chrome-picker': Chrome
  },
  data() {
    return {
      options: [],
      settings: [],
      removed: [],
      lang: '',
      load: false,
      // colors     : undefined,
      selectColor: undefined,
      selectImage: undefined,
      colorPicker: { x: 0, y: 0 }
    }
  },
  computed: {
    is_tag() {
      return this.selectedSettings.option_id === 'tags'
    },
    is_ingredient() {
      return this.selectedSettings.option_id === 'ingredient'
    },

    selected() {
      return this.options.find(i => i.option_id === this.option_id)
    },
    selectedSettings() {
      return this.settings.find(i => i.option_id === this.option_id)
    },
    list: {
      get() {
        return this.selected ? this.selected.list.sort((a, b) => a.order - b.order) : []
      },
      set(value) {
        this.selected.list = value
      }
    },
    colors: {
      get() {
        return this.selectColor ? this.selectColor.color ? this.selectColor.color : '#ffffff' : undefined;
      },
      set(value) {
        if (this.selectColor) {
          this.selectColor.color = value.hex
        }
      }
    }
  },
  mounted() {
    api.get('/api/options', { filter: this.filter, sortBy: this.sortBy })
      .then(response => response.data)
      .then(data => {
        this.settings = data.settings;
        this.options = data.result.filter(i => i.option_id !== 'category')
          .map(i => {
            i.list = i.list.map(l => Object.assign(l, { _id: l.id }));
            return i
          });
        // let idx       = this.options.findIndex(i => i.option_id === 'tags');
        // if (idx < 0) {
        //   this.options.push({option_id: 'tags', 'option': 'Тег', list: []});
        // }
        let idx = this.settings.findIndex(i => i.option_id === 'ingredient');
        if (idx < 0) {
          this.settings = [{ option_id: 'ingredient', 'option': this.$static('options.ingredientText', 'Позначки') }, ...this.settings];
        }
        idx = this.settings.findIndex(i => i.option_id === 'tags');
        if (idx < 0) {
          this.settings = [{ option_id: 'tags', 'option': this.$static('options.tagsText', 'Мітки') }, ...this.settings];
        }

        // console.log(this.option_id, this.options, this.options.length)
        // if (!this.option_id && this.options.length) {
        //   this.$router.replace({name: 'Options', params: {option_id: this.options[0].option_id}})
        // this.option_id = this.options[0].option_id
        // }
      })
  },
  methods: {
    openFileManager(item) {
      this.selectImage = item;
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select);
    },
    select() {
      let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      this.selectImage.image = images[0]
    },
    openColorPicker(event, item) {
      // console.log(event, item);
      if (this.selectColor !== undefined && this.selectColor.id === item.id) {
        this.selectColor = undefined;
        return
      }
      this.colorPicker.x = event.pageX;
      this.colorPicker.y = event.pageY;
      this.selectColor = item;
      window.document.getElementById('app').addEventListener('click', this.closeColorPicker)
    },
    closeColorPicker(event) {
      this.selectColor = undefined;
      window.document.getElementById('app').removeEventListener('click', this.closeColorPicker)
    },
    getColor(color) {
      return color ? color : 'transparent'
    },
    swap(index1, index2) {
      if (index2 > this.list.length - 1 || index2 < 0) {
        return
      }
      let list = [...this.selected.list];
      list[index1].order = index2;
      list[index2].order = index1;
      this.selected.list = list;
    },
    addMore() {
      if (!this.selected && this.selectedSettings) {
        this.options.push(
          {
            option: this.selectedSettings.option,
            option_id: this.selectedSettings.option_id,
            list: [
              {
                option_id: this.selectedSettings.option_id,
                option: this.selectedSettings.option,
                name: 'New',
                info: { hidden: false },
                _id: new Date().getTime(),
                order: this.list ? this.list.length : 1
              }
            ]
          });
        return
      }
      let more = Object.assign({}, this.list[this.list.length - 1], {
        color: null,
        image: null,
        option_id: this.selectedSettings.option_id,
        option: this.selectedSettings.option
      });
      more.order = this.list.length;
      more.id = undefined;
      delete more.translate;
      more._id = new Date().getTime();
      this.selected.list.push(more);
    },
    remove(index) {
      if (this.selected.list[index]['id'] !== undefined) {
        let id = this.selected.list[index]['id'];
        if (this.load) {
          return
        }
        this.load = true;
        api.delete(`/api/options/${id}`).then(response => response.data).then(data => {
          if (data.error) {
            this.$notify({
              title: 'Info',
              text: data.message
            });
            return
          }
          this.load = false;
          let list = [...this.selected.list];
          let removed = list.splice(index, 1);
          this.removed.push(removed[0]);
          this.selected.list = list;
        }).catch(e => this.load = false);
      } else {
        this.list.splice(index, 1);
      }
    },
    save() {
      if (this.load) {
        return
      }
      this.load = true;
      this.list = this.list.map(i => {
        i.image = i.image ? i.image : null;
        return i
      });
      api.post('/api/options', { list: this.list, removed: this.removed }).then(response => response.data).then(
        data => {
          // console.log(data)
          this.load = false;
          this.removed = [];
          this.selected.list = data.map(l => Object.assign(l, { _id: l.id }));
          // console.log(data)
          this.$notify({
            title: this.$static('options.title', 'Опції'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
        })
    }
  }
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 1s;
}

.list-complete-enter,
.list-complete-leave-to

/* .list-complete-leave-active до версии 2.1.8 */
  {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}
</style>